<template>
  <div class="white-box position-relative">
    <TileLoader :loading="loading"/>
    <div class="header-container">
      <h2>Stats : Alerte baisse CA</h2>
      <div>
        <a target="_blank"
           rel="noreferrer"
           :href="getDroneRedirectUrl('reports/6-2-4')"
        >
          <button class="btn-cmem">
            Voir le rapport
          </button>
        </a>
      </div>
    </div>
    <table class="datas-table">
      <thead>
      <tr>
        <th>Fournisseur</th>
        <th class="number">Prog. CA</th>
        <th>Période</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row of datas.slice(0, 5)" :key="row.FrsGuid">
        <td>
          <router-link :to="{path: '/dashboard-cdm/rdv', query: {frsGuid: row.FrsGuid}}">
            {{ row.FrsName }}
          </router-link>
        </td>
        <td class="number">{{ Math.round(row.ProgCa * 10000) / 100 }}&nbsp;%</td>
        <td>{{ row.PeriodLabel }}</td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script>
import TileLoader from "../../Dashboards/TileLoader.vue";
import {getSimFixeAlertesBaisse, getStatsAlerts} from "@/utils/dashboardCdm";
import store from "@/store/dashboards";
import {getDroneRedirectUrl} from "@/helpers/getRedirectUrlHelper";

export default {
  components: {TileLoader},
  name: 'StatsAlertsTile',
  data() {
    return {
      loading: 0,
      datas: [],
      store
    }
  },
  watch: {
    storeGlobalView() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    getDroneRedirectUrl,
    initData() {
      this.loading = 1;
      getStatsAlerts(this.storeGlobalView).then(res => {
        if (res.length)
          this.datas = res;
        this.loading = 0;
      })
    },
    formatEuro(value, precision = 2) {
      return Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: precision
      }).format(value);
    },
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    }
  }
}
</script>

<style scoped>
.white-box {
  flex: 1 1 25em;
  padding: 12px;

  display: flex;
  flex-direction: column;
}

.header-container {
  display: flex;
  justify-content: space-between;
  column-gap: 12px;
}

h2 {
  display: flex;
  align-items: center;

  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

p {
  margin: 0;
}

.datas-table thead {
  border-bottom: 1px solid black;
}

.datas-table th, .datas-table td {
  padding: 2px 8px;
}

.datas-table tbody tr:nth-child(odd) {
  background-color: #EFEFEF;
}

.datas-table tbody tr:nth-child(even) {
  background-color: #C5C5C5;
}

.datas-table a {
  color: inherit;
  text-decoration: none;
}

.datas-table td.with-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.datas-table .number {
  text-align: right;
}

.datas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.datas-table .tag > div.green {
  background-color: #388E3C;
}

.datas-table .tag > div.orange {
  background-color: #FFC107;
}

.datas-table .tag > div.red {
  background-color: #D32F2F;
}

.trend-indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  font-size: 0.8em;
}

.trend-indicator.up {
  color: #388E3C;
}

.trend-indicator.up::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23388E3C%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%2017l6-6l4%204l8-8%22%2F%3E%3Cpath%20d%3D%22M17%207h4v4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

.trend-indicator.down {
  color: #D32F2F;
}

.trend-indicator.down::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23D32F2F%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%207l6%206l4-4l8%208%22%2F%3E%3Cpath%20d%3D%22M17%2017h4v-4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

</style>



// WEBPACK FOOTER //
// src/components/DashboardCdm/Stats/StatsAlertsTile.vue